import { useState } from "react";
import { Box } from "../../../../../../components/box";
import InformationLayout from "../../../../components/layout/InformationLayout";
import FormButton from "./button";
import FormContent from "./content";

const ItDeleteAccountInformation = () => {
  /**
   * Form states
   */
  const [assignList, setAssignList] = useState<any>([]);

  return (
    <InformationLayout>
      <Box title="Thông tin xóa tài khoản" className="full-height">
        <FormContent setAssignList={setAssignList} />
        <FormButton assignList={assignList} />
      </Box>
    </InformationLayout>
  );
};

export default ItDeleteAccountInformation;
